// extracted by mini-css-extract-plugin
module.exports = {"menu":"AuthNav_menu__1DAjL","item":"AuthNav_item__jDs3O"};